import { SIDE_NAV_WIDTH, SITE_HEADER_HEIGHT } from 'portal/constants/Constants';
import { Tablet } from 'styles/MediaQueries';
import ContainerComponent from '@opploans/container-component/Container';
import React from 'react';
import SideNav from 'portal/SideNav';
import Tabs from 'portal/Tabs';

const sideNavStyle = {
  minWidth: SIDE_NAV_WIDTH,
  width: SIDE_NAV_WIDTH,
  minHeight: `calc(100vh - ${SITE_HEADER_HEIGHT})`,
  [Tablet]: {
    display: 'none'
  }
};

function Container({
  additionalStyle,
  additionalOuterStyle,
  noBackground,
  children,
  navigate
}) {
  return (
    <ContainerComponent
      additionalStyle={additionalStyle}
      additionalOuterStyle={additionalOuterStyle}
      noBackground={noBackground}
      NavComponent={
        navigate &&
        (() => (
          <>
            <div css={sideNavStyle}>
              <SideNav navigate={navigate} />
            </div>
            <Tabs navigate={navigate} />
          </>
        ))
      }
    >
      {children}
    </ContainerComponent>
  );
}

export default Container;
